"use client";

import { useContext } from "react";
import { VariableContext } from "../../VariableContext";
import type { VariableContextType } from "../types/variable-types";

// ============================================================================
// VARIABLE CONTEXT HOOK
// ============================================================================

export function useVariableContext(): VariableContextType {
  const context = useContext(VariableContext);
  if (!context) {
    throw new Error("useVariableContext must be used within a VariableProvider");
  }
  return context;
}
